// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"da5422ed","437":"9151e191","561":"7445833a","579":"10a5512b","661":"e61bb086","764":"20418c9d","787":"d7ece244"}[chunkId] + ".chunk.js";
};